<script lang="ts">
import { defineComponent, ref, onMounted, onBeforeUnmount, PropType } from 'vue'
import { useRouter } from 'vue-router'

export interface SidebarMenuItem {
  to: string
  icon: string
  label: string
  exact?: boolean
  initialSidebarOpen?: boolean
}

export default defineComponent({
  name: 'SectionSidebar',
  props: {
    menuItems: {
      type: Array as PropType<SidebarMenuItem[]>,
      required: true
    }
  },
  setup(props) {
    const router = useRouter()
    const sidebarOpen = ref(true)
    const activeRoute = ref(router.currentRoute.value.path)

    function updateSidebarStateBasedOnRoute(path: string) {
      const matchingRoute = props.menuItems.find(item => item.to === path)
      if (matchingRoute && matchingRoute.initialSidebarOpen !== undefined) {
        sidebarOpen.value = matchingRoute.initialSidebarOpen
      }
    }

    function toggleSidebar() {
      sidebarOpen.value = !sidebarOpen.value
    }

    let removeAfterHook: (() => void) | null = null

    onMounted(() => {
      removeAfterHook = router.afterEach((to) => {
        activeRoute.value = to.path
        updateSidebarStateBasedOnRoute(to.path)
      })
      updateSidebarStateBasedOnRoute(router.currentRoute.value.path)
    })

    onBeforeUnmount(() => {
      if (removeAfterHook) {
        removeAfterHook()
      }
    })

    return {
      sidebarOpen,
      activeRoute,
      toggleSidebar
    }
  }
})
</script>

<template>
  <aside :class="['sidebar', { close: !sidebarOpen }]">
    <div class="sidebar-icon" @click="toggleSidebar">
      <div class="barr1" />
      <div class="barr2" />
      <div class="barr3" />
    </div>
    <div class="sidebar-icon close" @click="toggleSidebar">
      <div class="barr1" />
      <div class="barr2" />
      <div class="barr3" />
    </div>

    <ul class="sidebar-menu-set">
      <router-link v-for="item in menuItems" :key="item.to" :to="item.to">
        <div :class="['sidebar-menu-animate', { active: activeRoute === item.to || (!item.exact && activeRoute.startsWith(item.to + '/')) }]">
          <li :class="['sidebar-menu', { active: activeRoute === item.to || (!item.exact && activeRoute.startsWith(item.to + '/')) }]">
            <img :src="item.icon" class="sidebar-menu-icon" alt="" />
            <span>{{ item.label }}</span>
          </li>
        </div>
      </router-link>
    </ul>

    <!-- Slot pour widget supplémentaire en bas du sidebar -->
    <slot name="widget" />
  </aside>
</template>

<style scoped>
.sidebar-menu-animate {
  cursor: pointer;
}
</style>
